module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_adwords_call_count-ac1802b90941d5e77dbcd2453533d7a8.png";